export default __webpack_public_path__ + "static/media/uv2.b37280c4.svg";